"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const lodash_1 = require("lodash");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const apiActions = __importStar(require("api-actions"));
const components_1 = require("components");
const config_1 = require("config");
const utils_1 = require("utils");
const RefundRequestForm_1 = __importDefault(require("../forms/RefundRequestForm"));
const reducer_1 = require("../reducer");
function RefundRequest({ refundRequest, currentLocation, refundLoan, }) {
    const history = (0, react_router_dom_1.useHistory)();
    const location = (0, react_router_dom_1.useLocation)();
    const { accountMemberId, alphaeonAccountNumber, creditLimit, name, transaction, consumerCreditInstrumentType, } = location.state;
    const { amount, createdAt, locationName, planName, transactionId, transactionType, lineItems, programProductType, } = transaction;
    const lenderName = config_1.PROGRAM_PRODUCT_TYPE_TO_LENDER_NAME_MAP.get(programProductType) ?? 'ADS';
    const handleSubmit = async (values) => {
        if (transactionType == config_1.TRANSACTION_TYPE.LOAN) {
            try {
                await refundLoan(alphaeonAccountNumber, values.amount, currentLocation.locationId);
                handleSubmitSuccess();
            }
            catch (e) {
                (0, utils_1.toastError)(e.response.message);
            }
        }
        else if (lineItems && lineItems.length > 0 && values.lineItemIds) {
            try {
                const excludedValues = values.lineItemIds.map((lineItemId) => `lineItem${lineItemId}`);
                const filteredValues = (0, lodash_1.omit)(values, [
                    ...excludedValues,
                ]);
                await refundRequest({
                    ...filteredValues,
                    locationId: currentLocation.locationId,
                    refundedTransactionId: transactionId,
                    accountMemberId: accountMemberId,
                });
                handleSubmitSuccess();
            }
            catch (e) {
                (0, utils_1.toastError)(e.response.message);
            }
        }
        else {
            try {
                await refundRequest({
                    ...values,
                    locationId: currentLocation.locationId,
                    refundedTransactionId: transactionId,
                    accountMemberId: accountMemberId,
                });
                handleSubmitSuccess();
            }
            catch (e) {
                (0, utils_1.toastError)(e.response.message);
            }
        }
    };
    const handleSubmitSuccess = () => {
        (0, utils_1.toastSuccess)('Refund Success');
        history.push({
            pathname: `${config_1.REFUND_REQUEST_URL}${alphaeonAccountNumber}/complete`,
            state: {
                accountMemberId,
                alphaeonAccountNumber,
                creditLimit,
                name,
                transaction,
                consumerCreditInstrumentType,
            },
        });
    };
    const goToAccountDetailPage = () => {
        history.push(`${config_1.ACCOUNT_DETAIL_URL}${alphaeonAccountNumber}`);
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", { className: "account-lookup m-t-30", children: [(0, jsx_runtime_1.jsx)("h1", { children: "Refund Request" }), (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", { className: "account-summary summary refund-request", children: [(0, jsx_runtime_1.jsx)("div", { className: "summary__info m-t-20", children: "You have requested a refund to this credit account. Please confirm the information below before finalizing the refund." }), (0, jsx_runtime_1.jsx)("div", { className: "summary__card card m-t-30", children: (0, jsx_runtime_1.jsx)("div", { className: "card-content", children: (0, jsx_runtime_1.jsxs)("div", { className: "summary__account-info", children: [(0, jsx_runtime_1.jsxs)("p", { className: "card-title", children: [' ', name.firstName, " ", name.lastName] }), (0, jsx_runtime_1.jsxs)("div", { className: "info-container sub-title", children: [(0, jsx_runtime_1.jsx)("p", { className: "card-area", children: "Account Number:" }), (0, jsx_runtime_1.jsx)(components_1.AccountNumber, { accountNumberString: alphaeonAccountNumber })] }), (0, jsx_runtime_1.jsxs)("div", { className: "card-main", children: [(0, jsx_runtime_1.jsxs)("div", { className: "card-main__left", children: [(0, jsx_runtime_1.jsx)("div", { className: "info-container ", children: (0, jsx_runtime_1.jsxs)("p", { className: "card-area", children: [(0, jsx_runtime_1.jsx)("strong", { children: "Transaction Date" }), ' ', (0, utils_1.formatISODateStringAsUSMonthDayYear)(createdAt)] }) }), (0, jsx_runtime_1.jsx)("div", { className: "info-container", children: (0, jsx_runtime_1.jsxs)("p", { className: "card-area", children: [(0, jsx_runtime_1.jsx)("strong", { children: "Plan" }), " ", planName] }) }), (0, jsx_runtime_1.jsx)("div", { className: "info-container", children: (0, jsx_runtime_1.jsxs)("p", { className: "card-area", children: [(0, jsx_runtime_1.jsx)("strong", { children: "Location" }), " ", locationName] }) })] }), (0, jsx_runtime_1.jsx)("div", { className: "card-main__right", children: (0, jsx_runtime_1.jsx)("div", { className: "info-container", children: (0, jsx_runtime_1.jsxs)("p", { className: "card-area", children: [(0, jsx_runtime_1.jsx)("strong", { children: "Total Sale Amount " }), ' ', (0, utils_1.formatCurrency)(amount, 2)] }) }) })] })] }) }) }), (0, jsx_runtime_1.jsx)(components_1.H3, { variant: "headline-small", className: "m-t-50 refund-request--header", children: "Refund Information" }), (0, jsx_runtime_1.jsx)(RefundRequestForm_1.default, { handleSubmit: handleSubmit, handleCancel: goToAccountDetailPage, lineItems: lineItems, lenderName: lenderName })] }) })] }) }));
}
function mapStateToProps(state) {
    return {
        currentLocation: reducer_1.selectors.currentLocation(state),
    };
}
const mapApiAuthToProps = {
    refundRequest: apiActions.refundRequest,
    adjustLoan: apiActions.adjustLoan,
    cancelLoan: apiActions.cancelLoan,
    refundLoan: apiActions.refundLoan,
};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps), (0, utils_1.withApiAuth)(mapApiAuthToProps))(RefundRequest);
